import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout'
import { hasAuthLogin,doLogout} from '@/utils/auth.js'

Vue.use(Router)

export const constRoutes=[
  {
    path: '/',
    name: 'index',
    title:'首页',
    icon:'home',
    hasChildren:false,
    isIndex:true,
    component: () => import('@/page/index')
  },
  {
    path: '/login',
    name: 'login',
    title:'登陆页',
    hasChildren:false,
    component: () => import('@/page/login')
  },
  {
    path: '/usercommission',
    name: 'usercommission',
    title:'会员佣金配置',
    hasChildren:false,
    component: () => import('@/page/usercommission')
  },
  {
    path: '/import',
    name: 'import',
    title:'导入数据源',
    icon:'upload2',
    hasChildren:false,
    component: () => import('@/page/import')
  },
  {
    path: '/mimport',
    name: 'mimport',
    title:'管理数据源',
    icon:'list',
    hasChildren:false,
    component: () => import('@/page/mimport')
  },
  {
    path: '/content',
    name: 'content',
    title:'分销商管理',
    icon:'shop',
    hasChildren:true,
    component: Layout, 
    children:[
      {
        path: '/addUser',
        name: 'addUser',
        title:'基础信息录入',
        icon:'add',
        component: () => import('@/page/adduser') 
      },{
        path: '/userlist',
        name: 'userlist',
        title:'会员列表',
        icon:'list',
        component: () => import('@/page/userlist') 
      },{
        path: '/addbindbee',
        name: 'addbindbee',
        title:'添加医院小蜜蜂',
        icon:'add',
        component: () => import('@/page/addbindbee') 
      },{
        path: '/beelist',
        name: 'beelist',
        title:'管理医院小蜜蜂',
        icon:'list',
        component: () => import('@/page/beelist') 
      }
    ]
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/page/404') 
  },{
      path: '*',
      redirect: '404'
  }
]

const router=new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes:constRoutes
})

router.beforeEach((to, from, next)=>{
      if(hasAuthLogin(to.name)){
          next()
      }else{
          doLogout()
          router.push({name:'login',replace:true}).catch(()=>{})
      }
})

export function goTo(url){
  router.push(url).catch(()=>{}) 
}

export default router
